<footer>
  <div class="container">
    <!-- This `*ngIf` should be here to avoid the footer to be hidden when is null -->
    <!-- because when all options are empty in Admin, the language selector must be visible -->
    <ng-container *ngIf="footerData$ | async as footerData">
      <section *ngIf="!isLandingPage()" class="sector-1">
        <div *ngIf="footerData.personalInfo" class="personal-info">
          <div [innerHTML]="footerData.personalInfo"></div>
        </div>

        <div *ngIf="footerData.links.length > 0" class="links">
          <ul>
            <li *ngFor="let link of footerData.links">
              <a [href]="link.url" target="_blank" rel="noopener">{{ link.title }}</a>
            </li>
          </ul>
        </div>

        <div *ngIf="footerData.social.length > 0 || footerData.appStores.length > 0" class="social">
          <div *ngIf="footerData.social.length > 0" class="social-networks">
            <opac-button
              *ngFor="let network of footerData.social"
              [ariaLabel]="network.title" [opacTooltip]="network.title"
              (click)="onSocialButtonClick(network)"
            >
              <opac-icon [icon]="network.icon" slot="only-icon"></opac-icon>
            </opac-button>
          </div>

          <div *ngIf="footerData.appStores.length > 0" class="app-stores">
            <a
              *ngFor="let appStore of footerData.appStores"
              [href]="appStore.url"
              rel="noopener"
              target="_blank"
              [title]="appStore.title"
            >
              <img aria-hidden="true" [alt]="appStore.title" [src]="appStore.image">
            </a>
          </div>
        </div>
      </section>

      <section
      *ngIf="footerLogos().length > 0 && !isLandingPage()"
      class="sector-2"
      [class.is-aula-madrid]="footerData.clientCode === aulaMadridClientCode"
      [class.shrink]="sidebarOpen$ | async"
    >
      <img *ngFor="let logo of footerLogos(); let i = index" [alt]="footerLogosAlt()[i]" [src]="logo">
    </section>
    </ng-container>

    <section class="sector-3">
      <div class="developer-info"> <!-- this div should stay to keep the 320px width -->
        <ng-container *ngIf="showDevelopmentInfo">
          <div class="logo">
            <span>{{ 'footer.developedBy' | translate }}</span>
            <a href="{{ odiloUrl() }}" rel="noopener">
              <img [src]="odiloDevelopedSrc" alt="Letmino">
            </a>
          </div>
          <div class="version">
            {{ opacVersion }} <b>|</b> {{ customerVersion() }}
          </div>
        </ng-container>
      </div>

      <div class="privacy-info">
        <div *ngIf="!isAulaDigital">© Letmino {{ copyrightYear }}. {{ 'footer.rights' | translate }}</div>
        <div *ngIf="showAccessibilityCookieLinks" class="links-container">
          <a routerLink="/accessibility">{{ 'footer.accessibility-certificate' | translate }}</a>
          <a routerLink="/cookie-policy">{{ 'cookies.footer.policy' | translate }}</a>
          <a
            href="#"
            (click)="openCookieConfiguration($event)"
            (keydown.space)="openCookieConfiguration($event)"
            (keydown.enter)="openCookieConfiguration($event)"
            >{{ 'cookies.footer.configuration' | translate }}
          </a>
        </div>
      </div>

      <div class="selectors-container">
        <div *ngIf="highContrastEnabled$ | async" class="high-contrast-selector">
          <opac-button
            class="high-contrast-button"
            type="text"
            [opac-menu-trigger]="highContrastMenu"
            [ariaLabel]="highContrastTooltip$ | async | translate" [opacTooltip]="highContrastTooltip$ | async | translate"
          >
            <div class="icon-container">
              <opac-icon icon="accessibility"></opac-icon>
              <opac-icon icon="expand_more"></opac-icon>
            </div>
          </opac-button>

          <opac-menu #highContrastMenu>
            <opac-menu-item (selected)="changeHighContrastMode(HighContrastMode.DISABLED)">
              <span>{{ 'footer.highContrast.disabled' | translate }}</span>
              <opac-icon *ngIf="(highContrastMode$ | async) === HighContrastMode.DISABLED" icon="check"></opac-icon>
            </opac-menu-item>

            <opac-menu-item (selected)="changeHighContrastMode(HighContrastMode.LIGHT)">
              <span>{{ 'footer.highContrast.light' | translate }}</span>
              <opac-icon *ngIf="(highContrastMode$ | async) === HighContrastMode.LIGHT" icon="check"></opac-icon>
            </opac-menu-item>

            <opac-menu-item (selected)="changeHighContrastMode(HighContrastMode.DARK)">
              <span>{{ 'footer.highContrast.dark' | translate }}</span>
              <opac-icon *ngIf="(highContrastMode$ | async) === HighContrastMode.DARK" icon="check"></opac-icon>
            </opac-menu-item>
          </opac-menu>
        </div>

        <div *ngIf="languageCodes.length > 1" class="language-selector">
          <opac-icon class="language-icon" [ariaHidden]="false" [attr.aria-label]="'footer.selectLanguage' | translate"
                     icon="language"></opac-icon>

          <opac-button
            class="language-button"
            type="primary"
            [opac-menu-trigger]="languageMenu"
            [ariaLabel]="('footer.selectLanguage' | translate) + ' ' + selectedLanguage | languageCodeToName" [opacTooltip]="('footer.selectLanguage' | translate) + ' ' + selectedLanguage | languageCodeToName"
          >
            <span>{{ selectedLanguage | languageCodeToName }}</span>
            <opac-icon icon="expand_more" slot="end"></opac-icon>
          </opac-button>

          <opac-menu #languageMenu>
            <opac-menu-item *ngFor="let lang of languageCodes" (selected)="changeLanguage(lang)">
              <span>{{ lang | languageCodeToName }}</span>
              <opac-icon *ngIf="selectedLanguage === lang" icon="check"></opac-icon>
            </opac-menu-item>
          </opac-menu>
        </div>
      </div>
    </section>
  </div>
</footer>
